export class MetricCategoryHelperService {

  constructor($state) {
    this.$state = $state;
    this.selectedCategoryId = null;
    this.updateSideNavFn = null;
  }

  setUpdateSideNavFn(updateSideNavFn) {
    this.updateSideNavFn = updateSideNavFn;
  }

  getSelectedCategoryId() {
    return this.selectedCategoryId;
  }

  setSelectedCategoryId(selectedCategoryId, stateName) {
    this.selectedCategoryId = selectedCategoryId;
    if (this.updateSideNavFn) {
      this.updateSideNavFn(stateName);
    }
  }

  routeToBestEffortMetric(metrics, toCategoryId, state) {
    for (let category of metrics) {
      if (!toCategoryId || toCategoryId === category.id) {
        this.setSelectedCategoryId(category.id, this.$state.current.name);
        this.$state.go(state, {
          'metricId': category.metrics.length > 0 ? category.metrics[0].id : category["subcategories"][0].metrics[0].id
        });
        break; // otherwise we'll call $state.go for every category
      }
    }
  }


  static MetricCategoryHelperFactory($state) {
    return new MetricCategoryHelperService($state);
  }
}
MetricCategoryHelperService.MetricCategoryHelperFactory.$inject = ['$state'];

